// import { get } from "lodash-es";

export const parser_login = (response) => {
  try {
    if (response?.data) {
      response = response.data;
    }
    if (!response) {
      return {};
    }
    return response;
  } catch (error) {
    throw new Error(error);
  }
};